export default __webpack_public_path__ + "static/media/emoji.b6a84bcc.svg";